// Using CJS instead of ESM because test-backend is failing when integrated to FEBE.
const { createStitches } = require('@stitches/react');

const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = createStitches({
  // Other configurations can be found here. https://stitches.dev/docs/api#createstitches
  media: {
    mobile: '(min-width: 375px)',
    tablet: '(min-width: 768px)',
    desktop: '(min-width: 1024px)',
  },
  utils: {
    marginX: (value) => ({ marginLeft: value, marginRight: value }),
    marginY: (value) => ({ marginTop: value, marginBottom: value }),
    size: (width, height) => ({ width, height }),
  },
  prefix: 'pf-comp-lib',
});

module.exports = {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
};

require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');